import Vue from 'vue'
import { UTILS, DOM, AUDIO } from '../utils'
import { API } from '../api'
import App from '../../App.vue'
import store from '../store'
import router from '../router'
import { WEIXIN } from '../../modules/weixin'

export default {
    checkLogin() {
        
        this.renderView();

        let me = this, userInfo;
        // 超过30min后，删除数据，重新授权登录
        var oldTime = parseInt(localStorage.getItem('H5_Fate_TimeStamp'));
        var newTime = parseInt((new Date()).getTime());
        var temp = parseInt((newTime - oldTime) / 1000 / 60 / 60);
        if(temp > 30) {
            localStorage.removeItem("H5_Fate_UserInfo");
        }
        userInfo = JSON.parse(localStorage.getItem("H5_Fate_UserInfo"));
        console.log('userInfo-----', temp, userInfo);
        // 其他平台用sessionstorage缓存用户登录信息
        if (userInfo && userInfo.token) {
            store.state.userData = userInfo;
            store.state.userInfo = userInfo.info;
        }else{
            me.thirdLogin();
            return;
        }
    },
    /**
     * 跳转到微信授权登录
     */
    thirdLogin() {
        var code = UTILS.getQueryString("code");     // 注意：1个code请求登录thirdLogin的接口只能请求1次
        console.log('thirdLogin----', code);
        if(!code || code == '') { return; }
        var params = code ? { 'code': code, 'type': 3 } : null;
        if (params) {
            API.thirdLogin(params, function (data) {
				store.state.gotUserInfo = true;
                store.state.userData = data;
                store.state.userInfo = data.info;
                localStorage.setItem("H5_Fate_TimeStamp", (new Date()).getTime());
                localStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
                console.log('thirdLogin-----微信授权登录成功', data);
            }, function (data) {
                console.error("thirdLogin-----微信授权登录失败", data.status_code);
            });
        }
    },
    /**
     * 第三方登录失败
     */
    loginFailed() {
        // window.location = WEIXIN.getWechatAuthUrl();
        console.error('loginFailed-------');
    },
    /**
     * 渲染页面
     */
    renderView() {
        // 初始化vue的app
        window.AppFate = new Vue({
            el: '#app',
            template: '<App/>',
            router,
            store,
            components: { App }
        });
    },
}